import { useTranslation } from 'react-i18next'

export function AidaGeneratingRing() {
  const { t } = useTranslation('components')
  return (
    <span
      role="status"
      aria-label={t('studio.components.aida.media_generating')}
      className="pointer-events-none absolute inset-0 text-theme_semantic_surface_expressive_violet_default"
    >
      <svg
        viewBox="0 0 36 36"
        aria-hidden="true"
        className="size-full animate-spin motion-reduce:animate-none"
      >
        <circle
          cx="18"
          cy="18"
          r="15"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeDasharray="24 70"
        />
      </svg>
    </span>
  )
}
